(() => {
  function formatMoney(cents, format) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, format);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function initOnegProductHero(root) {
    if (!root || root.dataset.ogHeroInitialized === 'true') return;
    root.dataset.ogHeroInitialized = 'true';

    const variantsEl = root.querySelector('[data-og-variants]');
    const stepContentEl = root.querySelector('[data-og-step-content]');
    if (!variantsEl || !stepContentEl) return;

    const variants = JSON.parse(variantsEl.textContent);
    const stepContent = JSON.parse(stepContentEl.textContent);

    const optionNames = {
      quantity: root.dataset.optionQuantity || 'Quantity',
      tablecloth: root.dataset.optionTablecloth || 'Tablecloth',
      fishCutlery: root.dataset.optionFishCutlery || 'Fish Cutlery'
    };

    const quantitySuffix = root.dataset.quantitySuffix || 'guests';
    const moneyFormat = root.dataset.moneyFormat || '${{amount}}';

    const notes = {
      default: root.dataset.noteDefault || '',
      tableclothYes: root.dataset.noteTableclothYes || 'with tablecloth',
      tableclothNo: root.dataset.noteTableclothNo || 'without tablecloth',
      cutleryYes: root.dataset.noteCutleryYes || 'with extra fish cutlery',
      cutleryNo: root.dataset.noteCutleryNo || 'without extra fish cutlery'
    };

    const labels = {
      locked: root.dataset.labelLocked || 'Complete your configuration',
      ready: root.dataset.labelReady || 'Add to cart',
      unavailable: root.dataset.labelUnavailable || 'Unavailable'
    };

    const selections = {
      [optionNames.quantity]: null,
      [optionNames.tablecloth]: null,
      [optionNames.fishCutlery]: null
    };

    const stepOrder = [
      optionNames.quantity,
      optionNames.tablecloth,
      optionNames.fishCutlery
    ];

    const stepMap = {
      1: optionNames.quantity,
      2: optionNames.tablecloth,
      3: optionNames.fishCutlery
    };

    const reverseStepMap = {
      [optionNames.quantity]: 1,
      [optionNames.tablecloth]: 2,
      [optionNames.fishCutlery]: 3
    };

    const mediaItems = Array.from(root.querySelectorAll('[data-og-media-item]'));
    const thumbs = Array.from(root.querySelectorAll('[data-og-thumb]'));
    const navButtons = Array.from(root.querySelectorAll('[data-nav-step]'));
    const steps = Array.from(root.querySelectorAll('.og-selection-step'));
    const form = root.querySelector('[data-og-product-form]');
    const variantIdInput = root.querySelector('[data-og-variant-id]');
    const addToCartBtn = root.querySelector('[data-og-add-to-cart]');
    const addToCartText = root.querySelector('[data-og-add-to-cart-text]');
    const priceEl = root.querySelector('[data-og-price]');
    const selectionNoteEl = root.querySelector('[data-og-selection-note]');
    const contextStepEl = root.querySelector('[data-og-context-step]');
    const contextTitleEl = root.querySelector('[data-og-context-title]');
    const contextTextEl = root.querySelector('[data-og-context-text]');
    const progressFill = root.querySelector('[data-og-progress-fill]');
    const progressText = root.querySelector('[data-og-progress-text]');

    let activeStep = 1;
    let activeGalleryMediaId =
      thumbs[0]?.dataset.mediaId ||
      mediaItems.find((item) => item.dataset.mediaId)?.dataset.mediaId ||
      null;

    function setActiveMediaItem(predicate) {
      let matched = false;

      mediaItems.forEach((item) => {
        const isMatch = predicate(item);
        item.classList.toggle('is-active', isMatch);
        if (isMatch) matched = true;

        const videos = item.querySelectorAll('video');
        videos.forEach((video) => {
          if (isMatch) {
            const playPromise = video.play();
            if (playPromise && typeof playPromise.catch === 'function') {
              playPromise.catch(() => {});
            }
          } else {
            video.pause();
          }
        });
      });

      return matched;
    }

    function showGalleryMedia(mediaId) {
      if (!mediaId) return;
      activeGalleryMediaId = mediaId;

      setActiveMediaItem((item) => item.dataset.mediaId === mediaId);

      thumbs.forEach((thumb) => {
        thumb.classList.toggle('is-active', thumb.dataset.mediaId === mediaId);
      });
    }

    function showContextMedia(stepNumber) {
      const key = 'step' + stepNumber;
      const content = stepContent[key];

      if (!content || !content.contextMedia) {
        if (activeGalleryMediaId) showGalleryMedia(activeGalleryMediaId);
        return;
      }

      thumbs.forEach((thumb) => thumb.classList.remove('is-active'));

      const found = setActiveMediaItem(
        (item) => item.dataset.ogContextMedia === content.contextMedia
      );

      if (!found && activeGalleryMediaId) {
        showGalleryMedia(activeGalleryMediaId);
      }
    }

    function updateContext(stepNumber) {
      const key = 'step' + stepNumber;
      const content = stepContent[key];
      if (!content) return;

      if (contextStepEl) contextStepEl.textContent = content.stepLabel || '';
      if (contextTitleEl) contextTitleEl.textContent = content.title || '';
      if (contextTextEl) contextTextEl.innerHTML = content.text || '';

      if (stepNumber === 1) {
        if (activeGalleryMediaId) showGalleryMedia(activeGalleryMediaId);
      } else {
        showContextMedia(stepNumber);
      }
    }

    function updateProgress() {
      let completed = 0;
      stepOrder.forEach((name) => {
        if (selections[name]) completed += 1;
      });

      const currentShown = Math.min(completed + 1, 3);
      const percent = (completed / 3) * 100;

      if (progressFill) progressFill.style.width = percent + '%';
      if (progressText) {
        progressText.textContent =
          completed === 3 ? 'Configuration complete' : `Step ${currentShown} of 3`;
      }
    }

    function updateNavState() {
      navButtons.forEach((button) => {
        const stepNumber = Number(button.dataset.navStep);
        const stepKey = stepMap[stepNumber];
        const valueEl = button.querySelector('[data-nav-value]');
        const isUnlocked = stepNumber === 1 || !!selections[stepMap[stepNumber - 1]];

        button.classList.toggle('is-active', stepNumber === activeStep);
        button.classList.toggle('is-locked', !isUnlocked);
        button.dataset.locked = isUnlocked ? 'false' : 'true';

        let value = '—';
        if (selections[stepKey]) {
          if (stepKey === optionNames.quantity) {
            value = `${selections[stepKey]} ${quantitySuffix}`;
          } else {
            value = selections[stepKey];
          }
        }

        if (valueEl) valueEl.textContent = value;
      });
    }

    function openStep(stepNumber) {
      activeStep = stepNumber;

      steps.forEach((stepEl) => {
        const currentStep = Number(stepEl.dataset.step);
        const isActive = currentStep === stepNumber;
        stepEl.classList.toggle('is-active', isActive);
        stepEl.hidden = !isActive;
      });

      updateContext(stepNumber);
      updateProgress();
      updateNavState();
    }

    function updateSelectionNote() {
      if (!selectionNoteEl) return;

      const parts = [];

      if (selections[optionNames.quantity]) {
        parts.push(`${selections[optionNames.quantity]} ${quantitySuffix}`);
      }

      if (selections[optionNames.tablecloth]) {
        parts.push(
          selections[optionNames.tablecloth] === 'Yes'
            ? notes.tableclothYes
            : notes.tableclothNo
        );
      }

      if (selections[optionNames.fishCutlery]) {
        parts.push(
          selections[optionNames.fishCutlery] === 'Yes'
            ? notes.cutleryYes
            : notes.cutleryNo
        );
      }

      selectionNoteEl.textContent = parts.length ? parts.join(' · ') : notes.default;
    }

    function updateVariant() {
      const isComplete =
        selections[optionNames.quantity] &&
        selections[optionNames.tablecloth] &&
        selections[optionNames.fishCutlery];

      if (!isComplete) {
        if (addToCartBtn) addToCartBtn.disabled = true;
        if (addToCartText) addToCartText.textContent = labels.locked;
        return;
      }

      const matchedVariant = variants.find((variant) => {
        return (
          variant.option1 === selections[optionNames.quantity] &&
          variant.option2 === selections[optionNames.tablecloth] &&
          variant.option3 === selections[optionNames.fishCutlery]
        );
      });

      if (!matchedVariant) {
        if (addToCartBtn) addToCartBtn.disabled = true;
        if (addToCartText) addToCartText.textContent = labels.unavailable;
        return;
      }

      if (variantIdInput) variantIdInput.value = matchedVariant.id;
      if (priceEl) priceEl.textContent = formatMoney(matchedVariant.price, moneyFormat);

      if (!matchedVariant.available) {
        if (addToCartBtn) addToCartBtn.disabled = true;
        if (addToCartText) addToCartText.textContent = labels.unavailable;
        return;
      }

      if (addToCartBtn) addToCartBtn.disabled = false;
      if (addToCartText) addToCartText.textContent = labels.ready;
    }

    function selectOption(optionWrap, optionButton) {
      const optionName = optionWrap.dataset.optionName;
      const value = optionButton.dataset.value;
      if (!optionName || !value) return;

      optionWrap.querySelectorAll('.og-selection-option').forEach((button) => {
        button.classList.remove('is-selected');
      });
      optionButton.classList.add('is-selected');

      selections[optionName] = value;

      updateSelectionNote();
      updateVariant();
      updateNavState();

      const currentStep = reverseStepMap[optionName];
      const nextStep = Math.min(currentStep + 1, 3);

      if (currentStep < 3) {
        openStep(nextStep);
      } else {
        openStep(3);
      }
    }

    root.addEventListener('click', (event) => {
      const thumb = event.target.closest('[data-og-thumb]');
      if (thumb) {
        showGalleryMedia(thumb.dataset.mediaId);
        if (activeStep === 1) updateContext(1);
        return;
      }

      const navButton = event.target.closest('[data-nav-step]');
      if (navButton) {
        const stepNumber = Number(navButton.dataset.navStep);
        const isLocked = navButton.dataset.locked === 'true';
        if (isLocked) return;
        openStep(stepNumber);
        return;
      }

      const optionButton = event.target.closest('.og-selection-option');
      if (!optionButton) return;

      const optionWrap = optionButton.closest('.og-selection-options');
      if (!optionWrap) return;

      selectOption(optionWrap, optionButton);
    });

    if (form) {
      form.addEventListener('submit', (event) => {
        if (addToCartBtn && addToCartBtn.disabled) {
          event.preventDefault();
        }
      });
    }

    if (activeGalleryMediaId) {
      showGalleryMedia(activeGalleryMediaId);
    }

    openStep(1);
    updateSelectionNote();
    updateVariant();
  }

  function initAllOnegProductHeroes() {
    document.querySelectorAll('[data-og-product-hero]').forEach((root) => {
      initOnegProductHero(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllOnegProductHeroes);
  } else {
    initAllOnegProductHeroes();
  }

  document.addEventListener('shopify:section:load', initAllOnegProductHeroes);
})();

document.addEventListener('click', function (e) {
  const btn = e.target.closest('[data-og-scroll-to-product]');
  if (!btn) return;

  const productSection = document.querySelector('[data-og-product-hero]');
  if (!productSection) return;

  productSection.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
});